import React from 'react';

function Footer() {
  return (
    <>
        <section id="footer">
            <footer className="top">
                <img src="/img/logo.png" alt='Logo de foot pro manager' />
                <div className="links">
                <div className="links-column">
                    <h2>FootProManager</h2>
                    <a href='/'><span>Accueil</span></a>
                    <a href='/equipe'><span>Equipes</span></a>
                    <a href='/contact'><span>Contact</span></a>
                    <a href='/connexion'><span>Connexion</span></a>
                    <a href='/inscription'><span>Inscription</span></a>
                </div>
                <div className="links-column">
                    <h2>Inscris ton équipe !
                    </h2>
                    <p>
                        Rejoignez-nous aujourd'hui et découvrez un monde où l'amitié, le travail d'équipe et la victoire se rencontrent. 
                    </p>
                </div>
                </div>
            </footer>
            <footer className="bottom">
                <p className="copyright">© 2026 Lassois Patrick</p>
                <div className="legal">
                </div>
            </footer>
        </section>
    
    </>
  );
}

export default Footer;
